var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23535 1.98532C4.23535 1.76603 4.41312 1.58826 4.63241 1.58826H16.8089C17.0282 1.58826 17.2059 1.76603 17.2059 1.98532C17.2059 2.20461 17.0282 2.38237 16.8089 2.38237H4.63241C4.41312 2.38237 4.23535 2.20461 4.23535 1.98532Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529297 1.98532C0.529297 1.76603 0.707066 1.58826 0.926356 1.58826H1.98518C2.20447 1.58826 2.38224 1.76603 2.38224 1.98532C2.38224 2.20461 2.20447 2.38237 1.98518 2.38237H0.926356C0.707066 2.38237 0.529297 2.20461 0.529297 1.98532Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23535 6.74996C4.23535 6.53067 4.41312 6.35291 4.63241 6.35291H16.8089C17.0282 6.35291 17.2059 6.53067 17.2059 6.74996C17.2059 6.96925 17.0282 7.14702 16.8089 7.14702H4.63241C4.41312 7.14702 4.23535 6.96925 4.23535 6.74996Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529297 6.74996C0.529297 6.53067 0.707066 6.35291 0.926356 6.35291H1.98518C2.20447 6.35291 2.38224 6.53067 2.38224 6.74996C2.38224 6.96925 2.20447 7.14702 1.98518 7.14702H0.926356C0.707066 7.14702 0.529297 6.96925 0.529297 6.74996Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23535 11.5147C4.23535 11.2954 4.41312 11.1177 4.63241 11.1177H16.8089C17.0282 11.1177 17.2059 11.2954 17.2059 11.5147C17.2059 11.734 17.0282 11.9118 16.8089 11.9118H4.63241C4.41312 11.9118 4.23535 11.734 4.23535 11.5147Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529297 11.5147C0.529297 11.2954 0.707066 11.1177 0.926356 11.1177H1.98518C2.20447 11.1177 2.38224 11.2954 2.38224 11.5147C2.38224 11.734 2.20447 11.9118 1.98518 11.9118H0.926356C0.707066 11.9118 0.529297 11.734 0.529297 11.5147Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23535 16.2794C4.23535 16.0601 4.41312 15.8823 4.63241 15.8823H16.8089C17.0282 15.8823 17.2059 16.0601 17.2059 16.2794C17.2059 16.4987 17.0282 16.6764 16.8089 16.6764H4.63241C4.41312 16.6764 4.23535 16.4987 4.23535 16.2794Z",
    fill: "inherit"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529297 16.2794C0.529297 16.0601 0.707066 15.8823 0.926356 15.8823H1.98518C2.20447 15.8823 2.38224 16.0601 2.38224 16.2794C2.38224 16.4987 2.20447 16.6764 1.98518 16.6764H0.926356C0.707066 16.6764 0.529297 16.4987 0.529297 16.2794Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.c0d4d025b4213831e23beb86524491db.svg";
export { ForwardRef as ReactComponent };